import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const dune: ThemeDefinition = {
  label: "Dune",
  className: "theme-dune",
  bg: "#e8d5a8",
  text: "#6b4c2a",
  textMuted: `color-mix(in srgb, #6b4c2a 60%, transparent)`,
  accent: "#b87040",
  glassRgb: "232,213,168",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, #6b4c2a 30%, transparent)`,
  selection: "#6b4c2a",
  selectionText: "#ffffff",
  gridColor: "#d4c090",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(40,30,10,0.18)",
  gpuClear: hexToSrgb("#e8d5a8"),
  gpuGridLine: hexToLinear("#d4c090"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#b87040"),
  gpuAxisZ: hexToLinear("#6b4c2a"),
  axisXColor: "#b87040",
  axisZColor: "#6b4c2a",
  font: '"Libre Baskerville", serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap',
};
